module.exports = __webpack_public_path__ + "static/media/gainon_swiggy_background.038a6b38.png";